import { render } from "./IncidentDetails.vue?vue&type=template&id=0b3396c0"
import script from "./IncidentDetails.vue?vue&type=script&lang=js"
export * from "./IncidentDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__